import { IDevicesStore } from './types';

const initStore: IDevicesStore = {
  items: [],
  pagination: {
    page: 0,
    itemsPerPage: 20,
    hasMore: false,
  },
};

export default initStore;
